import { useTranslation } from 'react-i18next'

import { useMeineSitzung } from '../api/queries'
import { useFehleranzeige } from '../api/text'

/**
 * Zeigt, ob jemand angemeldet ist.
 *
 * Klein, aber der erste echte Verbraucher der API-Anbindung: er beweist an einem
 * laufenden System, dass generierte Typen, Cookie-Weitergabe, Fehlerauspacken und
 * die Unterscheidung „nicht angemeldet" ↔ „nicht erreichbar" zusammenspielen.
 * Die eigentliche Hülle mit Nutzermenü baut IS-34.
 */
export function Sitzungsstand() {
  const { t } = useTranslation()
  const anzeige = useFehleranzeige()
  const { data, error, isPending } = useMeineSitzung()

  if (isPending) {
    return <p className="text-sm text-text-muted">{t('rahmen.sitzung.laedt')}</p>
  }

  if (error) {
    const { text, requestId } = anzeige(error)
    return (
      <p className="rounded-imp border border-error-line bg-error px-3 py-2 text-sm text-error-text">
        {text}
        {requestId && <span className="ml-2 opacity-80">{t('api.kennung', { id: requestId })}</span>}
      </p>
    )
  }

  if (!data) {
    return (
      <div className="text-sm">
        <p className="font-semibold text-heading">{t('rahmen.sitzung.abgemeldet')}</p>
        <p className="mt-1 text-text-muted">{t('rahmen.sitzung.hinweis_anmeldung')}</p>
      </div>
    )
  }

  return (
    <p className="text-sm font-semibold text-heading">
      {t('rahmen.sitzung.angemeldet', {
        name: data.user.display_name,
        rolle: data.user.role,
      })}
    </p>
  )
}
